import { render } from "./ResourceComponent.vue?vue&type=template&id=08fa1ba2&scoped=true"
import script from "./ResourceComponent.vue?vue&type=script&lang=js"
export * from "./ResourceComponent.vue?vue&type=script&lang=js"

import "@/assets/css/resources.sass?vue&type=style&index=0&id=08fa1ba2&lang=sass&scoped=true"
import "@/assets/css/loading.sass?vue&type=style&index=1&id=08fa1ba2&lang=sass&scoped=true"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08fa1ba2"]])

export default __exports__